<template>
  <div
    aria-live="polite"
    aria-atomic="true"
    class="toast-container d-flex justify-content-center align-items-center"
  >
    <div class="toast-outer">
      <div
        v-for="(alert, index) in alerts"
        :key="index"
        class="toast fade show"
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div class="toast-header">
          <i
            class="toast-icon fas"
            :class="[
              /error|fail/i.test(alert.type) ? 'red' : 'green',
              /error|fail/i.test(alert.type)
                ? 'fa-exclamation-circle'
                : 'fa-check-circle',
            ]"
          ></i>
          <strong class="mr-auto">{{ alert.title }}</strong>
          <button
            @click="close(alert)"
            type="button"
            class="close"
            data-dismiss="toast"
            aria-label="Закрыть"
          ></button>
        </div>
        <div class="toast-body">
          <span v-html="alert.message"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";

import config from "../config.js";

export default {
  data() {
    return {
      alerts: [],
    };
  },

  methods: {
    close(alert) {
      const index = this.alerts.indexOf(alert);
      if (index !== -1) {
        this.alerts.splice(index, 1);
      }
    },
    show(alert) {
      alert.message = _.toString(alert.message, "").replace(/:\n*/, ":<br />");

      this.alerts.push(alert);

      let timeout = parseFloat(alert.timeout);
      if (isNaN(timeout)) {
        const fail = /error|fail/i.test(alert.type);
        timeout = fail ? config.alerts.failTimeout : config.alerts.okTimeout;
      }
      if (timeout === 0) {
        timeout = 1e6;
      }
      setTimeout(() => {
        this.close(alert);
      }, timeout * 1000);
    },

    ok(message, title) {
      this.show({
        message,
        title: title || config.alerts.defaultOkTitle,
        type: "ok",
      });
    },
    fail(message, title) {
      this.show({
        message,
        title: title || config.alerts.defaultFailTitle,
        type: "fail",
      });
    },
    error(message, title) {
      this.fail(message, title);
    },
  },
};
</script>
